import React, { useState } from 'react';
import type { Photo } from 'app/types/commonTypes.type';
import { TourLightbox } from './TourLightbox';
import { TourPreviewCard } from './TourPreviewCard';
import * as styles from './mediaCenter.styles';

type ThreeDTourTabProps = {
  tourUrls: Array<string>;
  tourLabels?: Array<string>;
  photos?: Array<Photo>;
  previewPhoto?: Photo;
};

export const ThreeDTourTab = ({ tourUrls, tourLabels = [], photos = [], previewPhoto }: ThreeDTourTabProps) => {
  const [activeTourIndex, setActiveTourIndex] = useState<number | null>(null);

  const getTourLabel = (index: number) => tourLabels[index] || `3D Tour ${index + 1}`;

  if (tourUrls.length === 0) {
    return (
      <div role="tabpanel" id="tabpanel-3dtour" aria-labelledby="tab-3dtour">
        <p className={styles.emptyState}>No 3D tour available for this listing.</p>
      </div>
    );
  }

  return (
    <div role="tabpanel" id="tabpanel-3dtour" aria-labelledby="tab-3dtour" className={styles.tourContainer}>
      {tourUrls.length === 1 ? (
        <TourPreviewCard
          photo={photos[0]}
          previewPhoto={previewPhoto}
          onClick={() => setActiveTourIndex(0)}
          label={getTourLabel(0)}
        />
      ) : (
        <div className={styles.tourList}>
          {tourUrls.map((_, i) => (
            <TourPreviewCard
              key={i}
              photo={photos[i]}
              previewPhoto={previewPhoto}
              onClick={() => setActiveTourIndex(i)}
              label={getTourLabel(i)}
            />
          ))}
        </div>
      )}

      {activeTourIndex !== null && (
        <TourLightbox
          tourUrl={tourUrls[activeTourIndex]}
          open={true}
          onOpenChange={(open) => {
            if (!open) setActiveTourIndex(null);
          }}
        />
      )}
    </div>
  );
};
